<template>
  <main class="bg-gray-200 min-h-screen">
    <header class="">
      <div
        class="border-b border-gray-300 px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8"
      >
        <div class="flex-1 min-w-0">
          <h1 class="text-lg font-medium leading-6 text-gray-900 sm:truncate">
            {{ $t('profile_title') }}
          </h1>
        </div>
      </div>
      <sqr-progress v-show="loading" />
      <sqr-error-banner :error="loadError" />
    </header>
    <section class="py-10 md:px-2 lg:px-4">
      <div class="max-w-lg">
        <div class="columns is-centered">
          <div class="bg-white rounded shadow p-4">
            <p class="text-sm text-medium text-gray-700 mb-3">
              {{ $t('profile_subtitle') }}
            </p>

            <div class="mb-6">
              <label class="block text-sm leading-5 font-medium text-gray-700">
                {{ $t('profile_photo') }}
              </label>
              <div class="mt-2 flex items-center">
                <span
                  class="inline-block h-12 w-12 rounded-full overflow-hidden bg-gray-100"
                >
                  <svg
                    v-if="!user || !user.photoURL"
                    class="h-full w-full text-gray-300"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"
                    />
                  </svg>
                  <img
                    :src="user.photoURL"
                    class="h-full w-full text-gray-300 object-cover"
                  />
                </span>
                <span class="ml-5 rounded-md shadow-sm">
                  <input
                    ref="photo"
                    type="file"
                    class="hidden"
                    @change="upload"
                  />
                  <sqr-button
                    :label="$t('profile_photo_change')"
                    @click="$refs.photo.click()"
                    color="light"
                    :loading="uploading"
                  />
                </span>
              </div>
            </div>

            <div class="mb-6" v-if="doc">
              <div class="grid grid-cols-2 gap-x-4">
                <sqr-input-text
                  :label="$t('user_given_name')"
                  :value="doc.givenName"
                  @change="fieldSetBis({ field: 'givenName', value: $event })"
                />
                <sqr-input-text
                  :label="$t('user_family_name')"
                  :value="doc.familyName"
                  @change="fieldSetBis({ field: 'familyName', value: $event })"
                />
              </div>
            </div>

            <div class="" v-if="user">
              <sqr-input-email
                :label="$t('profile_email')"
                :value="user.email"
                @change="emailChange"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

import SqrProgress from '@/components/SqrProgress';
import SqrErrorBanner from '@/components/SqrErrorBanner';
import SqrButton from '@/components/SqrButton';
import SqrInputText from '@/components/SqrInputText';
import SqrInputEmail from '@/components/SqrInputEmail';

export default {
  name: 'Profile',
  components: {
    SqrProgress,
    SqrErrorBanner,
    SqrButton,
    SqrInputText,
    SqrInputEmail
  },
  computed: {
    ...mapGetters('auth', ['uid', 'user']),
    ...mapState('profile', ['doc', 'loading', 'loadError'])
  },
  data() {
    return {
      uploading: false,
      uploadError: null
    };
  },
  mounted() {
    this.$a().logEvent('profile');
  },
  methods: {
    ...mapActions('auth', ['displayNameSet']),
    async fieldSetBis({ field, value }) {
      try {
        await this.$db()
          .doc(this.dco.path)
          .update({ [field]: value });
        const profile = this.doc;
        await this.displayNameSet({
          displayName: [profile.givenName, profile.familyName]
            .filter(v => v)
            .join(' ')
        });
      } catch (error) {
        console.log(error);
      }
    },
    async emailChange(value) {
      try {
        this.$fb()
          .auth()
          .currentUser.updateEmail(value);
      } catch (error) {
        console.log(error);
      }
    },
    async emailVerify() {
      this.verifying = true;
    },
    async upload() {
      try {
        this.uploading = true;
        this.uploadError = null;
        const file = this.$refs.photo.files[0];
        const ref = this.$fs().ref(`profiles/${this.uid}/profile`);
        await ref.put(file);
        const photoURL = await ref.getDownloadURL();
        return await this.$fb()
          .auth()
          .currentUser.updateProfile({ photoURL });
      } catch (error) {
        this.uploadError = error;
      } finally {
        this.uploading = false;
      }
    }
  }
};
</script>
